import * as actionTypes from './actionTypes';
import { TypeVehicleModel } from '@app/src/views/StepOne/form/models/typeVehicle';

interface State {
  data: TypeVehicleModel[];
  isFetching: boolean;
  error: boolean;
}

const initialState: State = {
  data: [],
  isFetching: false,
  error: false
}

export const typeVehicle = (state = initialState, action): State => {
  switch (action.type) {
    case actionTypes.FETCH_TYPE_VEHICLE_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case actionTypes.FETCH_TYPE_VEHICLE_FAILURE:
      return {
        ...state,
        isFetching: false,
        error: true
      }
    case actionTypes.FETCH_TYPE_VEHICLE_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: false,
        data: action.data
      }
    default:
      return state;
  }
}
